import { render, staticRenderFns } from "./CoursesPreview.vue?vue&type=template&id=c890503e&scoped=true&"
import script from "./CoursesPreview.vue?vue&type=script&lang=js&"
export * from "./CoursesPreview.vue?vue&type=script&lang=js&"
import style0 from "./CoursesPreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CoursesPreview.vue?vue&type=style&index=1&id=c890503e&lang=scss&scoped=true&"
import style2 from "./CoursesPreview.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c890503e",
  null
  
)

export default component.exports